export default __webpack_public_path__ + "static/media/WM0480.34I-43870_-26186_0.7b16a392.jpg";